<template>
  <div class="compressed-content">
    <h3 class="page-question">
      Have you EVER experienced symptoms or treatment for blockages in your arteries including angina 
      (chest pain from blockage in heart arteries), leg pain from an artery blockage (claudication), 
      stroke or “mini stroke”, heart attack, or had any procedure to fix a blocked heart, neck, or leg artery 
      (angioplasty, stent, bypass surgery)?
    </h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hadArteryBlockage">
      <b-form-radio v-model="survey.arteryBlockages.arteryBlockage.hadArteryBlockage" name="blockage" 
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.arteryBlockages.arteryBlockage.hadArteryBlockage" name="blockage" 
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      hadArteryBlockage: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      hadArteryBlockage() { return this.survey.arteryBlockages.arteryBlockage.hadArteryBlockage; }
    }
  };
</script>